import React from 'react';

import { Typography } from '@mui/material';

export default function DealFieldLabel({ children }: { children: React.ReactNode }) {
  return (
    <Typography
      variant="caption"
      color="text.secondary"
      fontWeight={600}
      sx={{ letterSpacing: 0.5, whiteSpace: 'nowrap' }}
    >
      {children}
    </Typography>
  );
}
